import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export interface IGerarPdfOptions {
  containerElement: HTMLElement;
  documentTitle: string;
  onProgress?: (current: number, total: number) => void;
}

export async function gerarPdfPropostaDireto({
  containerElement,
  documentTitle,
  onProgress
}: IGerarPdfOptions): Promise<void> {
  const slideRoots = containerElement.querySelectorAll<HTMLElement>('.slide-container-root');
  const targets = slideRoots.length > 0 ? Array.from(slideRoots) : Array.from(containerElement.querySelectorAll<HTMLElement>('.slide-print-wrapper'));

  if (!targets.length) {
    throw new Error('Nenhum slide encontrado para exportação');
  }

  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'px',
    format: [1920, 1080],
    compress: true
  });

  const total = targets.length;

  for (let i = 0; i < total; i++) {
    const slideEl = targets[i];
    if (onProgress) {
      onProgress(i + 1, total);
    }

    const canvas = await html2canvas(slideEl, {
      scale: 1.25,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: 1920,
      windowHeight: 1080
    });

    const imgData = canvas.toDataURL('image/jpeg', 0.92);

    if (i > 0) {
      pdf.addPage([1920, 1080], 'landscape');
    }

    pdf.addImage(imgData, 'JPEG', 0, 0, 1920, 1080, undefined, 'FAST');
  }

  const filename = documentTitle.endsWith('.pdf') ? documentTitle : `${documentTitle}.pdf`;
  const pdfBlob = pdf.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);
  const downloadLink = document.createElement('a');
  downloadLink.href = blobUrl;
  downloadLink.download = filename;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
}
